import productSnowfoam from "@/assets/product-snowfoam.jpg";
import productShampoo from "@/assets/product-shampoo.jpg";
import productCeramic from "@/assets/product-ceramic.jpg";
import productWheelcleaner from "@/assets/product-wheelcleaner.jpg";

export interface Product {
  id: string;
  slug: string;
  name: string;
  price: number;
  originalPrice?: number;
  image: string;
  rating: number;
  reviewCount: number;
  badge?: string;
  category: string;
  description: string;
  inStock: boolean;
  seoKeywords?: string;
}

export const categories = [
  { id: "all", name: "Alle Producten", count: 12 },
  { id: "exterior", name: "Exterieur", count: 5 },
  { id: "interior", name: "Interieur", count: 2 },
  { id: "wheels", name: "Wielen", count: 2 },
  { id: "protection", name: "Bescherming", count: 2 },
  { id: "bundles", name: "Bundels met Korting", count: 1 },
  { id: "accessories", name: "Accessoires", count: 0 },
];

export const products: Product[] = [
  {
    id: "1",
    slug: "alien-snow-foam",
    name: "Alien Snow Foam",
    price: 24.99,
    originalPrice: 29.99,
    image: productSnowfoam,
    rating: 5,
    reviewCount: 127,
    badge: "Bestseller",
    category: "exterior",
    description: "Ultra-dikke snow foam voor auto's en motoren - maximale reiniging",
    inStock: true,
    seoKeywords: "Snow Foam Auto | Motor Snow Foam",
  },
  {
    id: "2",
    slug: "galactic-shampoo",
    name: "Galactic Shampoo",
    price: 19.99,
    image: productShampoo,
    rating: 5,
    reviewCount: 89,
    category: "exterior",
    description: "pH-neutraal auto- en motorshampoo met extreme glans",
    inStock: true,
    seoKeywords: "Auto Shampoo | Motor Shampoo",
  },
  {
    id: "3",
    slug: "cosmic-ceramic-spray",
    name: "Cosmic Ceramic Spray",
    price: 34.99,
    image: productCeramic,
    rating: 4,
    reviewCount: 156,
    badge: "Nieuw",
    category: "protection",
    description: "Professionele keramische bescherming voor auto en motor",
    inStock: true,
    seoKeywords: "Ceramic Coating Auto | Keramische Bescherming",
  },
  {
    id: "4",
    slug: "nebula-wheel-cleaner",
    name: "Nebula Wheel Cleaner",
    price: 22.99,
    image: productWheelcleaner,
    rating: 5,
    reviewCount: 94,
    category: "wheels",
    description: "Krachtige velgenreiniger voor auto- en motorvelgen",
    inStock: true,
    seoKeywords: "Velgenreiniger | Wheel Cleaner",
  },
  {
    id: "5",
    slug: "plasma-quick-detailer",
    name: "Plasma Quick Detailer",
    price: 17.99,
    image: productCeramic,
    rating: 5,
    reviewCount: 203,
    category: "exterior",
    description: "Snelle glans voor auto en motor tussen wasbeurten",
    inStock: true,
    seoKeywords: "Quick Detailer | Snelle Autoglans",
  },
  {
    id: "6",
    slug: "orbit-interior-cleaner",
    name: "Orbit Interior Cleaner",
    price: 21.99,
    image: productShampoo,
    rating: 4,
    reviewCount: 78,
    category: "interior",
    description: "All-purpose interieur reiniger voor auto en motor",
    inStock: true,
    seoKeywords: "Interieur Reiniger Auto | Dashboard Cleaner",
  },
  {
    id: "7",
    slug: "meteor-iron-remover",
    name: "Meteor Iron Remover",
    price: 26.99,
    image: productWheelcleaner,
    rating: 5,
    reviewCount: 112,
    badge: "Populair",
    category: "wheels",
    description: "Kleurveranderende ijzerdeeltjesverwijderaar voor alle voertuigen",
    inStock: true,
    seoKeywords: "Iron Remover | Vliegroest Verwijderaar",
  },
  {
    id: "8",
    slug: "starship-wax",
    name: "Starship Wax",
    price: 39.99,
    originalPrice: 49.99,
    image: productCeramic,
    rating: 5,
    reviewCount: 167,
    badge: "-20%",
    category: "protection",
    description: "Premium carnauba wax voor auto's en motoren",
    inStock: true,
    seoKeywords: "Auto Wax | Carnauba Wax",
  },
  {
    id: "9",
    slug: "galaxy-glass-cleaner",
    name: "Galaxy Glass Cleaner",
    price: 14.99,
    image: productShampoo,
    rating: 4,
    reviewCount: 89,
    category: "exterior",
    description: "Streepvrije glasreiniger voor auto- en motorruiten",
    inStock: true,
    seoKeywords: "Glasreiniger Auto | Ruitenreiniger",
  },
  {
    id: "10",
    slug: "lunar-leather-care",
    name: "Lunar Leather Care",
    price: 28.99,
    image: productSnowfoam,
    rating: 5,
    reviewCount: 56,
    category: "interior",
    description: "All-in-one leerverzorging voor auto en motor zadels",
    inStock: true,
    seoKeywords: "Leeronderhoud Auto | Leather Care",
  },
  {
    id: "11",
    slug: "comet-tire-dressing",
    name: "Comet Tire Dressing",
    price: 18.99,
    image: productWheelcleaner,
    rating: 4,
    reviewCount: 134,
    category: "exterior",
    description: "Langdurige autobandenglans zonder vette residue",
    inStock: false,
    seoKeywords: "Bandenglans | Tire Dressing",
  },
  {
    id: "12",
    slug: "microfiber-doeken-set",
    name: "Microfiber Doeken Set",
    price: 29.99,
    image: productSnowfoam,
    rating: 5,
    reviewCount: 245,
    badge: "Bundle",
    category: "bundles",
    description: "Premium microfiber doeken voor auto- en motorverzorging",
    inStock: true,
    seoKeywords: "Microfiber Doeken | Auto Poetsdoeken",
  },
];

// Helper function to find product by slug
export const getProductBySlug = (slug: string): Product | undefined => {
  return products.find((p) => p.slug === slug);
};

// Helper function to find product by id (for backwards compatibility)
export const getProductById = (id: string): Product | undefined => {
  return products.find((p) => p.id === id);
};
